<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?(viewFlag?'查看Banner':'编辑Banner'):'新增Banner'" :visible.sync="dialog" @close="unShowClick()" width="45%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="Banner名称" prop="name" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" v-model="addBody.name"
						placeholder="请输入Banner名称"></el-input>
				</el-form-item>
				<el-form-item label="Banner位置" prop="type" :label-width="formLabelWidth">
					<el-select :disabled='viewFlag' style="width: 100%;" v-model="addBody.type"
						placeholder="请选择Banner位置">
						<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="图片" prop="img" :label-width="formLabelWidth">
					<img v-if="viewFlag" class="pointer"
						@click="viewImage(addBody.img.indexOf('http')!=-1? addBody.img:imgDomain+addBody.img)"
						:src="addBody.img.indexOf('http')!=-1? addBody.img:imgDomain+addBody.img" style="width: 150px;height: 150px;" />
					<ImageUpload v-else :limit='1' @input='imageUpload' :onloadImageList='onloadImageList'>
					</ImageUpload>
				</el-form-item>
				<el-form-item :disabled='viewFlag' label="权重" prop="weight" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" type='number' v-model="addBody.weight"
						placeholder="请输入权重"></el-input>
					<div style="color: #999;">*权重数字越大排序越靠前</div>
				</el-form-item>
				<el-form-item label="关联跳转链接" prop="link_type" :label-width="formLabelWidth">
					<el-radio-group :disabled='viewFlag' v-model="addBody.link_type" @change="changeRadio">
						<el-radio :label="1" style="margin-right: 60px;margin-bottom: 20px;">指定课程</el-radio>
						<el-radio :label="2" style="margin-right: 60px;margin-bottom: 20px;">指定培训</el-radio>
						<el-radio :label="3" style="margin-right: 60px;margin-bottom: 20px;">固定页面-关于我们</el-radio>
						<el-radio :label="4" style="margin-right: 60px;margin-bottom: 20px;">固定页面-服务据点</el-radio>
						<el-radio :label="5" style="margin-right: 60px;">核心技术</el-radio>
						<el-radio :label="6" style="margin-right: 60px;">外部链接</el-radio>
						<el-radio :label="7">不关联跳转</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 核心技术 -->
				<el-form-item label="跳转页面" prop="type" v-if="addBody.link_type == 5" :label-width="formLabelWidth">
					<el-select :disabled='viewFlag' style="width: 100%;" v-model="addBody.art_uuid"
						placeholder="请选择跳转页面">
						<el-option v-for="item in lmList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- 指定课程 -->
				<el-form-item label="跳转页面" prop="type" v-if="addBody.link_type == 1" :label-width="formLabelWidth">
					<el-select :disabled='viewFlag' style="width: 100%;" v-model="addBody.course_uuid"
						placeholder="请选择跳转页面">
						<el-option v-for="item in lmList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- 指定培训 -->
				<el-form-item label="跳转页面" prop="type" v-if="addBody.link_type == 2" :label-width="formLabelWidth">
					<el-select :disabled='viewFlag' style="width: 100%;" v-model="addBody.train_uuid"
						placeholder="请选择跳转页面">
						<el-option v-for="item in lmList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="外部链接" prop="" v-if="addBody.link_type == 6" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" v-model="addBody.url"
						placeholder="请输入外部链接"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" v-if="!viewFlag" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateBanner('addBody')">确 定</el-button>
			</div>
		</el-dialog>

		<PriviewImgVue :previewImg="previewImg"></PriviewImgVue>
	</div>
</template>

<script>
	import PriviewImgVue from '@/components/PriviewImg.vue';
	import {
		addBanner,
		updateBanner,
		getBannerDetail,
		getArtList
	} from '@/api/views'
	import {
		getCourseList
	} from '@/api/course'
	import {
		getTrainList
	} from '@/api/train'
	import ImageUpload from "@/components/ImageUpload"
	import {
		imgDomain
	} from '@/configs/env';
	// import { getAuthListDetail, typeOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload,
			PriviewImgVue
		},
		data() {
			return {
				viewFlag: false,
				imgDomain,
				onloadImageList: [],
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					name: '',
					type: null, // 对应link_type
					img: '',
					weight: null,
					link_type: null,
					url: '',
					course_uuid: '',
					train_uuid: '',
					art_uuid: '',
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					type: [{
						required: true,
						message: '请选择位置',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
					link_type: [{
						required: true,
						message: '请选择关联跳转链接',
						trigger: 'blur'
					}, ],
					img: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				typeList: [{
						id: 1,
						name: '首页-顶部'
					},
					{
						id: 2,
						name: '首页-腰部'
					},
					{
						id: 3,
						name: '个人中心-腰部'
					},
				],
				lmList: [],
				previewImg: {
					popup: false,
					index: 0,
					imgList: []
				}
			}
		},
		mounted() {},
		methods: {
			setViewFlag(viewFlag){
				this.viewFlag = viewFlag
			},
			viewImage(url) {
				this.previewImg.imgList = []
				this.previewImg.imgList.push(url)
				this.previewImg.popup = true
			},
			imageUpload(e) {
				this.addBody.img = imgDomain + e[0]
			},
			changeRadio(e) {
				this.lmList = []
				if (e == 5) {
					//核心技术
					this.getArtList()
				}
				if (e == 1) {
					//指定课程
					this.getCourseList()
				}
				if (e == 2) {
					//指定培训
					this.getTrainList()
				}
			},
			async getArtList() {
				const {
					data,
					status
				} = await getArtList({
					page_index: 1,
					page_size: 9999
				})
				let arrs = data.result.data
				arrs.forEach(item => {
					let obj = {
						label: item.title,
						value: item.uuid
					}
					this.lmList.push(obj)
				})
			},
			async getCourseList() {
				const {
					data,
					status
				} = await getCourseList({
					page_index: 1,
					page_size: 9999
				})
				let arrs = data.result.data
				arrs.forEach(item => {
					let obj = {
						label: item.name,
						value: item.uuid
					}
					this.lmList.push(obj)
				})
			},
			async getTrainList() {
				const {
					data,
					status
				} = await getTrainList({
					page_index: 1,
					page_size: 9999
				})
				let arrs = data.result.data
				arrs.forEach(item => {
					let obj = {
						label: item.name,
						value: item.uuid
					}
					this.lmList.push(obj)
				})
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateBanner(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateBanner()
						} else {
							this.network().addBanner()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addBanner: async () => {
						const {
							status,
							data
						} = await addBanner({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateBanner: async () => {
						const {
							status
						} = await updateBanner({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getBannerDetail: async (uuid) => {
						const {
							data,
							status
						} = await getBannerDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
						this.onloadImageList.push(this.addBody.img)
						this.lmList = []
						if (this.addBody.link_type == 5) {
							//核心技术
							this.getArtList()
						}
						if (this.addBody.link_type == 1) {
							//指定课程
							this.getCourseList()
						}
						if (this.addBody.link_type == 2) {
							//指定培训
							this.getTrainList()
						}
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.onloadImageList = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getBannerDetail(val.uuid)
				} else {
					this.isEdit = false
					this.addBody.name = ''
					this.addBody.type = ''
					this.addBody.img = ''
					this.addBody.weight = ''
					this.addBody.link_type = ''
					this.addBody.url = ''
					this.addBody.course_uuid = ''
					this.addBody.train_uuid = ''
					this.addBody.art_uuid = ''
					this.addBody.uuid = ''
					this.onloadImageList = []
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>